import React from 'react'
import { EmployeeSelect, LocationSelect } from '@ui'
import StatusSelect, { getTicketStatus } from './StatusSelect'
import track, { RootEvent } from '@track'
import Event from '@track/Event'
import { UseTicketsHook } from './hooks/useTickets'
import { IBuildingDetails, IFloorDetails } from '@api'

export default function Filters({ tickets }: { tickets: UseTicketsHook }) {
  return (
    <div
      className="filters"
      style={{ minWidth: 200, padding: '5px 10px' }}
      onClick={(e) => e.stopPropagation()}
    >
      <table>
        <tbody>
          <tr>
            <td>Status</td>
            <td>
              <StatusSelect
                clearable
                value={tickets.ticketStatus ? getTicketStatus(tickets.ticketStatus) : null}
                onChange={(ticketStatus) => {
                  const trackPayload = ticketStatus
                    ? {
                        eventName: Event.FILTER,
                        props: {
                          filterName: 'Status',
                          filterValue: ticketStatus.label,
                        },
                      }
                    : {
                        eventName: Event.CLEAR_FILTER,
                        props: {
                          filterName: 'Status',
                          filterValue: null,
                        },
                      }
                  tickets.setTicketStatus(ticketStatus ? ticketStatus.value : null)
                  track.tickets(trackPayload as RootEvent)
                }}
              />
            </td>
          </tr>
          <tr>
            <td>Location</td>
            <td>
              <LocationFilter {...{ tickets }} />
            </td>
          </tr>
          <tr>
            <td>Assigned to</td>
            <td>
              <EmployeeFilter {...{ tickets, name: 'AssignedTo', filterName: 'Assigned to' }} />
            </td>
          </tr>
          <tr>
            <td>Created by</td>
            <td>
              <EmployeeFilter {...{ tickets, name: 'Employee', filterName: 'Created by' }} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const EmployeeFilter = ({
  tickets,
  name,
  filterName,
}: {
  tickets: UseTicketsHook
  name: string
  filterName: string
}) => {
  const onChange = (employee: any) => {
    const trackPayload = employee
      ? {
          eventName: Event.FILTER,
          props: {
            filterName,
            value: employee.name,
          },
        }
      : {
          eventName: Event.CLEAR_FILTER,
          props: {
            filterName,
            value: null,
          },
        }
    tickets.filter({ [name]: employee } as any)
    track.tickets(trackPayload as RootEvent)
  }
  const value = tickets.keyValueFilters[name]

  return <EmployeeSelect {...{ onChange, value, clearable: true }} />
}

const LocationFilter = ({ tickets }: { tickets: UseTicketsHook }) => {
  const onChange = (option?: IBuildingDetails | IFloorDetails) => {
    if (option) {
      if ('building' in option) {
        tickets.filter({ Floor: option })
      } else {
        tickets.filter({ Building: option })
      }
    } else {
      tickets.filter({ Floor: undefined, Building: undefined })
    }

    const trackPayload = option
      ? {
          eventName: Event.FILTER,
          props: {
            filterName: 'Location',
            filterValue: option.name,
          },
        }
      : {
          eventName: Event.CLEAR_FILTER,
          props: {
            filterName: 'Location',
            filterValue: null,
          },
        }

    track.tickets(trackPayload as RootEvent)
  }
  const value = tickets.keyValueFilters?.Floor?.id || tickets.keyValueFilters?.Building?.id || null

  return (
    <LocationSelect
      includeOldBuildings
      clearable
      mode={LocationSelect.Mode.SINGLE_BUILDING_FLOOR}
      {...{ onChange, value }}
    />
  )
}
